export const localstorageService = () =>
  typeof localStorage !== 'undefined'
    ? localStorage
    : {
        clear: () => undefined,
        getItem: () => undefined,
        key: () => null,
        removeItem: () => undefined,
        setItem: () => undefined,
      };
export const windowService = () => (typeof window !== 'undefined' ? window : {});
export const documentService = () => (typeof document !== 'undefined' ? document : {});

export const getExpiryDate = (day) =>{
  var d = new Date();
  d.setTime(d.getTime() + (day * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  return expires;
}

export const getCookieValue = (name) => {
  let result = '';
  
  if (typeof document !== 'undefined') {
  result = document.cookie.match("(^|[^;]+)\\s*" + name + "\\s*=\\s*([^;]+)");
  }
  return result ? result.pop() : ""
}
